import { uniqWith } from 'lodash-es'

import { DocumentSharePickerMutationTypes } from './mutation_types'
import { DocumentSharePickerState } from './state'

export const mutations: StoreMutations<DocumentSharePickerMutationTypes, DocumentSharePickerState> = {
  [DocumentSharePickerMutationTypes.ADD_GROUPS_TO_DISABLED](state, groups) {
    state.disabledGroups = uniqWith(
      [...state.disabledGroups, ...groups],
      (groupA, groupB) => groupA.id === groupB.id,
    )
  },
  [DocumentSharePickerMutationTypes.ADD_MEMBERS_TO_DISABLED](state, members: Member[]) {
    state.disabledMembers = uniqWith(
      [...state.disabledMembers, ...members],
      (a, b) => a.id === b.id,
    )
  },
  [DocumentSharePickerMutationTypes.SET_DISABLED_GROUPS](state, groups) {
    state.disabledGroups = groups
  },
  [DocumentSharePickerMutationTypes.SET_DISABLED_MEMBERS](state, members: Member[]) {
    state.disabledMembers = members
  },
  [DocumentSharePickerMutationTypes.ADD_GROUP_TO_SELECTED](state, group: Group) {
    const index = state.selectedGroups.findIndex(item => item.id === group.id)
    if (index < 0) {
      state.selectedGroups.push(group)
    }
  },
  [DocumentSharePickerMutationTypes.REMOVE_GROUP_FROM_SELECTED](state, group: Group) {
    const index = state.selectedGroups.findIndex(item => item.id === group.id)
    if (index >= 0) {
      state.selectedGroups.splice(index, 1)
    }
  },
  [DocumentSharePickerMutationTypes.SET_SELECTED_GROUPS](state, groups: Group[]) {
    state.selectedGroups = groups
  },
  [DocumentSharePickerMutationTypes.ADD_MEMBERS_TO_SELECTED](state, members: Member[]) {
    state.selectedMembers = uniqWith(
      [...state.selectedMembers, ...members],
      (a, b) => a.id === b.id,
    )
  },
  [DocumentSharePickerMutationTypes.REMOVE_MEMBERS_FROM_SELECTED](state, members: Member[]) {
    state.selectedMembers = state.selectedMembers.filter(
      member => members.findIndex(m => m.id === member.id) < 0,
    )
  },
  [DocumentSharePickerMutationTypes.SET_SELECTED_MEMBERS](state, members: Member[]) {
    state.selectedMembers = members
  },
  [DocumentSharePickerMutationTypes.SET_HIGHLIGHTED_MEMBER](state, member: Member | null) {
    state.highlightedMember = member
  },
}
